import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { TextField, Typography, Button, FormError } from "components";
import { Formik, Form, ErrorMessage } from "formik";
import { ROUTES, pocketMoniUrl } from "routes/routePaths";
import { routes } from "routes/apiRoutes";
import makeRequest from "services/makeRequest";
import { emailValidation } from "utils/validators";
import { GoMail } from "react-icons/go";
import AuthHeader from "./AuthHeader";
import AuthFooter from "./AuthFooter";
import resetImage from "assets/images/reset-image.png";
import pmLogo from "assets/images/pocketmoni-logo.png";
import * as Yup from "yup";
import "./style.scss";

const PasswordForgot = () => {
  const navigate = useNavigate();

  const [showError, setShowError] = useState(false);

  const validationSchema = Yup.object({
    email: emailValidation(),
  });

  const onSubmit = async (values) => {
    setShowError(false);

    try {
      const { data } = await makeRequest(
        "post",
        routes.forgotPassword(values.email)
      );
      if (data.responseCode.toString() === "200") {
        navigate(ROUTES.otpPage, { state: { email: values.email } });
      } else {
        setShowError(true);
      }
    } catch (error) {}
  };

  return (
    <div className="row m-0 auth-container">
      <div className="auth-header-container">
        <AuthHeader />
      </div>

      <div className="col-12 col-xl-6 p-0 auth-form-container">
        <div className="login-form">
          <div className="auth-intro">
            <div className="mb-4 d-xl-none">
              <a href={pocketMoniUrl} target="_blank" rel="noopener noreferrer">
                <img src={pmLogo} width="150" alt="PocketMoni" />
              </a>{" "}
            </div>
            <Typography component="h3" variant="heading3" state="primary">
              Reset your Password
            </Typography>
            <Typography variant="body3" state="primary">
              Enter your email address below to reset your password
            </Typography>
          </div>

          <Formik
            initialValues={{
              email: "",
            }}
            validationSchema={validationSchema}
            onSubmit={async (values) => await onSubmit(values)}
          >
            {({ errors, touched, getFieldProps, isSubmitting }) => (
              <Form noValidate autoComplete="off">
                {showError && (
                  <Typography
                    state="danger"
                    variant="body2"
                    className="text-center"
                  >
                    Incorrect email address!
                  </Typography>
                )}

                <div className="mb-4">
                  <TextField
                    name="email"
                    type="email"
                    placeholder="Enter Email Address"
                    label="Email Address"
                    {...getFieldProps("email")}
                    hasError={errors.email && touched.email}
                    startIcon={<GoMail color="#AAA6A6" fontSize="18px" />}
                  />
                  <ErrorMessage component={FormError} name="email" />
                </div>

                <Button
                  type="submit"
                  label="Get OTP"
                  fullWidth
                  loading={isSubmitting}
                />
              </Form>
            )}
          </Formik>
          <div className="text-center mt-2">
            <Typography component="span" variant="body3">
              Not Registered Yet?
            </Typography>{" "}
            <Link to={ROUTES.register}>
              <Typography variant="body2" state="primary" component="span">
                Become an Agent
              </Typography>
            </Link>
          </div>
        </div>

        <AuthFooter />
      </div>

      <div className="d-none d-xl-block col-xl-6 p-0">
        <img src={resetImage} width="100%" alt="Log In" />
      </div>
    </div>
  );
};

export default PasswordForgot;
